import { render, staticRenderFns } from "./ApprMndSet.vue?vue&type=template&id=324be4e1&scoped=true"
import script from "./ApprMndSet.vue?vue&type=script&lang=js"
export * from "./ApprMndSet.vue?vue&type=script&lang=js"
import style0 from "./ApprMndSet.vue?vue&type=style&index=0&id=324be4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324be4e1",
  null
  
)

export default component.exports